import { useState } from 'react';

export const useSendUrls = () => {
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);

  const sendUrls = async (urls) => {
    setLoading(true);
    setError(null);
    setResult(null);

    try {
      //   console.log('Sending URLs:', urls);
      const response = await fetch(
        `${process.env.REACT_APP_LANGFLOW_BASE_URL}/api/v1/run/5f9fe250-24f2-4a78-a293-be4557b5910a?stream=false`,
        {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_LANGFLOW_API_KEY}`,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            input_value: urls.join('\n'),
            output_type: 'chat',
            input_type: 'chat',
          }),
        }
      );

      const data = await response.json();

      if (response.ok) {
        setResult(data.result || 'ok, received');
        // console.log('LangFlow Response:', data);
      } else {
        setError(data.error || 'Unknown error');
        // console.error('LangFlow error:', data.error);
      }
    } catch (err) {
      setError(err.message || 'Connection error');
    } finally {
      setLoading(false);
    }
  };

  return { sendUrls, loading, result, error };
};
